<template>
  <section class="technologies editorial-section" id="technologies">
    <div class="section-kicker"><span>Technical forensics</span><span>03</span></div>
    <div class="section-title"><p>The lab report</p><h2>Tools found in regular use.</h2></div>

    <div class="technology-groups">
      <div class="technology-group">
        <h2>Languages</h2>

        <div class="technology-list">
          <span>Java</span>
          <span>C#</span>
          <span>PHP</span>
          <span>JavaScript</span>
          <span>Python</span>
          <span>SQL</span>
        </div>
      </div>

      <div class="technology-group">
        <h2>Frontend</h2>

        <div class="technology-list">
          <span>Vue.js</span>
          <span>React</span>
          <span>Ionic</span>
          <span>SCSS</span>
          <span>HTML / CSS</span>
        </div>
      </div>

      <div class="technology-group">
        <h2>Backend</h2>

        <div class="technology-list">
          <span>Node.js</span>
          <span>Express.js</span>
          <span>Spring Boot</span>
          <span>Symfony</span>
          <span>.NET</span>
        </div>
      </div>

      <div class="technology-group">
        <h2>Databases</h2>

        <div class="technology-list">
          <span>MySQL</span>
          <span>Microsoft SQL</span>
          <span>PostgreSQL</span>
        </div>
      </div>

      <div class="technology-group">
        <h2>DevOps & Infrastructure</h2>

        <div class="technology-list">
          <span>Git</span>
          <span>Docker</span>
          <span>Jenkins</span>
          <span>Vercel</span>
          <span>Nginx</span>
          <span>Linux</span>
          <span>CentOS</span>
          <span>Ubuntu</span>
        </div>
      </div>

      <div class="technology-group">
        <h2>Currently Exploring</h2>

        <div class="technology-list">
          <span>Cybersecurity</span>
          <span>Networking</span>
          <span>Linux Security</span>
          <span>Penetration Testing</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Technologies"
}
</script>
